import { createContext } from 'react';

export const LeagueContext = createContext({
  currentLeague: null,
  userLeagues: [],
  leagueMembers: [],
  isLeagueAdmin: false,
  switchLeague: () => {},
  refreshLeagueData: () => {},
  leagueDataVersion: 0
});